import script from "./AddNotesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNotesModal.vue?vue&type=script&setup=true&lang=js"

import "./AddNotesModal.vue?vue&type=style&index=0&id=34973d0e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34973d0e"]])

export default __exports__